import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, RocketIcon, LifeBuoyIcon, FolderIcon, ClockIcon, ClipboardCheckIcon, CheckIcon } from 'lucide-react';
const tomos = [{
  n: 'Tomo 1',
  name: 'El Motor de Planificación',
  promise: 'Nunca vuelvas a pasar todo el domingo planificando.',
  desc: 'Aprende el Sistema 3T para dejar lista toda tu semana docente en solo 30 minutos, sin empezar desde cero cada lunes.',
  Icon: RocketIcon,
  color: 'text-brandpurple',
  bg: 'bg-brandpurple/10'
}, {
  n: 'Tomo 2',
  name: 'Banco de Inicio y Cierre',
  promise: 'Jamás vuelvas a quedarte en blanco al empezar una clase.',
  desc: 'Descubre un banco de aperturas y cierres listos para captar la atención de tus alumnos desde el primer minuto.',
  Icon: BookOpenIcon,
  color: 'text-teal',
  bg: 'bg-teal/10'
}, {
  n: 'Tomo 3',
  name: 'Unidades de Supervivencia',
  promise: 'Cuando el lunes te sorprenda… tendrás un plan listo.',
  desc: 'Ten proyectos y sesiones de emergencia preparados para esos días donde no hubo tiempo de planificar.',
  Icon: LifeBuoyIcon,
  color: 'text-magenta',
  bg: 'bg-magenta/10'
}, {
  n: 'Tomo 4',
  name: 'El Archivador de Fichas',
  promise: 'Deja de perder horas buscando una ficha que sabes que tienes.',
  desc: 'Organiza recursos listos para usar y encuentra cualquier material en cuestión de segundos.',
  Icon: FolderIcon,
  color: 'text-navy',
  bg: 'bg-navy/10'
}, {
  n: 'Tomo 5',
  name: 'Gestión de Aula y Tiempo',
  promise: 'Recupera el control de tu aula sin llevarte trabajo a casa.',
  desc: 'Implementa rutinas simples que mantienen a tus estudiantes organizados y reducen el trabajo fuera del colegio.',
  Icon: ClockIcon,
  color: 'text-brandpurple',
  bg: 'bg-brandpurple/10'
}, {
  n: 'Tomo 6',
  name: 'Evaluación Invisible',
  promise: 'Corrige toda tu clase sin pasar otra noche frente a la computadora.',
  desc: 'Aprende un sistema práctico para evaluar rápidamente mientras enseñas y deja de llevar cuadernos a casa.',
  Icon: ClipboardCheckIcon,
  color: 'text-magenta',
  bg: 'bg-magenta/10'
}];
const includes = ['Listo para usar mañana sin editar', 'Funciona sin tecnología ni proyector', 'Adaptable a cualquier país de habla hispana', 'Versión para todos los niveles educativos', 'Un solo pago · 40 semanas resueltas'];
export function Tomos() {
  return <section className="bg-navy px-4 py-16 text-white" data-id="element-215" data-mp="2exaahe0zdr6d">
      <div className="mx-auto max-w-4xl text-center" data-id="element-216" data-mp="2ewin2qhjezr6">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-white/80" data-id="element-217" data-mp="2soyjv9jui1jn">
          🏆 Método Domingo Libre™
        </span>
        <h2 className="mt-4 font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-218" data-mp="32m3b3nsjsn7b">
          De 6 horas de angustia dominical a{' '}
          <span className="italic text-magenta" data-id="element-219" data-mp="2xp351cvp7kg7">28 minutos</span>.
        </h2>
        <p className="mt-3 text-white/70" data-id="element-220" data-mp="3had3latgub9g">Empezando este domingo.</p>

        <p className="mt-8 text-sm font-bold uppercase tracking-widest text-white/60" data-id="element-221" data-mp="3lan78gtscpl5">
          6 tomos completos
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-4xl gap-4 sm:grid-cols-2" data-id="element-222" data-mp="37acfzcokd8zg">
        {tomos.map((t, i) => <motion.div key={t.n} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.4,
        delay: i % 2 * 0.06
      }} className="flex items-start gap-4 rounded-2xl bg-white p-5 text-navy shadow-soft" data-id="element-223" data-mp="3c8nqlpmonniq" data-mpi={i}>
            <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${t.bg}`} data-id="element-224" data-mp="2eot18l4r5rfq">
              <t.Icon className={`h-6 w-6 ${t.color}`} data-id="element-225" data-mp="3mwyvgn3jg1ds" />
            </div>
            <div className="min-w-0" data-id="element-226" data-mp="3hxdy2h40o136">
              <div className="text-xs font-bold uppercase tracking-wide text-magenta" data-id="element-227" data-mp="3hyf9wnsuwrly">
                {t.n} · {t.name}
              </div>
              <h3 className="mt-1 font-display text-lg font-black leading-snug text-navy" data-id="element-228" data-mp="3d4ksxs4myqqk">
                {t.promise}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-navy/65" data-id="element-229" data-mp="338zlhegssy9f">
                {t.desc}
              </p>
            </div>
          </motion.div>)}
      </div>

      <div className="mx-auto mt-8 max-w-2xl rounded-2xl border border-white/15 bg-white/5 p-6" data-id="element-230" data-mp="2z98yllue72a6">
        <p className="mb-4 text-center text-sm font-bold uppercase tracking-wide text-white/70" data-id="element-231" data-mp="2u9mk792tvfzs">
          Cada tomo incluye:
        </p>
        <ul className="grid gap-2.5 sm:grid-cols-2" data-id="element-232" data-mp="sgoq79xbehd9">
          {includes.map(item => <li key={item} className="flex items-start gap-2.5 text-sm" data-id="element-233" data-mp="ngtu8ryon1lc">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" data-id="element-234" data-mp="v0usld6a5zrp" />
              <span className="text-white/85" data-id="element-235" data-mp="v0l1tndevoky">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}